var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShortColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_17790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2829 21.7633C11.9324 21.0662 11.3098 19.8277 13.0094 18.4187C13.4714 18.0357 15.1031 16.9817 17.1038 15.6894C19.5963 14.0795 22.6613 12.0997 24.7503 10.5868C25.1119 10.3249 25.3533 9.93395 25.4369 9.49521L27.0824 0.850691C27.2029 0.217511 26.4915 -0.24189 25.9642 0.128651L8.77921 12.2059C7.33515 13.1875 4.87182 15.4842 6.58187 18.5691C7.95349 21.0435 12.43 22.0834 12.43 22.0834C12.3996 21.9954 12.3456 21.888 12.2829 21.7633ZM23.7175 14.2294C24.068 14.9266 24.6906 16.165 22.9911 17.574C22.5291 17.957 20.8974 19.011 18.8967 20.3032C16.4043 21.9131 13.3393 23.8928 11.2503 25.4056C10.8887 25.6675 10.6473 26.0584 10.5638 26.4972L8.91845 35.1416C8.79794 35.7748 9.50938 36.2342 10.0366 35.8637L27.2215 23.7869C28.6655 22.8053 31.1288 20.5087 29.4187 17.4237C28.047 14.9493 23.5704 13.9094 23.5704 13.9094C23.6008 13.9973 23.6548 14.1047 23.7175 14.2294Z",
    fill: "url(#paint0_linear_105_17790)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_17790",
    x1: 18.0003,
    y1: 37.9087,
    x2: 32.456,
    y2: 2.54123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4756E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865173,
    stopColor: "#F93749"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_17790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShortColor);
export default __webpack_public_path__ + "static/media/logo-short-color.b1aadb83582b54d205972330af6bc4ac.svg";
export { ForwardRef as ReactComponent };